import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { ChooseModalParam } from 'src/app/models/choose-modal-param';
import { ChooseModalComponent } from '../choose-modal/choose-modal.component';
import { UserService } from 'src/app/services/user.service';
import { CompanyService } from 'src/app/services/company.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserIban } from 'src/app/models/user';

@Component({
    selector: 'iban-user-selector',
    templateUrl: './iban-selector.component.html',
})
export class IbanUserSelectorComponent implements ControlValueAccessor, OnInit {
    destroy$: Subject<boolean> = new Subject<boolean>();

    userIbans: UserIban[];
    disabled: boolean;
    /** Empresa Owner (se não tiver valor vai usar a empresa da sessão) */
    @Input() ownerID: number;
    /** Empresa User (se não tiver valor vai apenas vai buscar os IBANs da empresa Owner) */
    @Input() userID: number = null;

    //Coloca por defeito o 1º selecionado se só existir 1
    @Input() setDefault: boolean = false;
    @Output() selectedIBAN: EventEmitter<UserIban> = new EventEmitter();

    constructor(private _userService: UserService, @Optional() public ngControl: NgControl, private _translateService: TranslateService, private _dialog: MatDialog, private _authenticationService: AuthenticationService) {
        ngControl.valueAccessor = this;
    }

    async ngOnInit(): Promise<void> {
        // se tiver desativado o form (consulta) so vai buscar o registo guardado caso constrario vai buscar todos
        if (!this.userIbans)
            await this.getUserIbans();
    }

    async getUserIbans() {
        this.userIbans = await this._userService.getUserIBANs(this.userID).toPromise();

        if (!this.ngControl.control.value && this.setDefault)
            this.setDefaultIban();
    }

    selectUserIban() {
        this._translateService.get(['SELECT_IBAN', 'IBAN', 'OBSERVATIONS', 'BY_DEFAULT']).subscribe(response => {
            let aoColumns = [
                { 'data': 'ID' },
                { 'data': 'Iban', 'class': 'verticalMiddle', 'title': response['IBAN'] },
                { 'data': 'Observations', 'class': 'verticalMiddle', 'title': response['OBSERVATIONS'] },
                {
                    'data': 'isDefault', 'class': 'verticalMiddle text-center', 'title': response['BY_DEFAULT'],
                    'render': function (data: boolean, type: string, row: any, meta: any) {
                        return (data === true) ? '<span class="glyphicon glyphicon-ok"></span>' : '';
                    }
                },
            ];

            let columnDefs = [
                { 'targets': [0], 'visible': false }, // colocar como hidden
                { 'targets': [-1], 'orderable': false }, // nao permitir ordenar pelas colunas
            ];

            const dialogRef = this._dialog.open(ChooseModalComponent, {
                data: new ChooseModalParam(this.userIbans, null, response['SELECT_IBAN'], aoColumns, columnDefs, null, 1, null),
                disableClose: true // nao permitir fechar modal com escape ou clique fora
            });

            dialogRef.afterClosed().subscribe((id: number) => {
                if (id) {
                    const found = this.userIbans.find(pc => pc.ID === id);
                    if (found) {
                        this.ngControl.control.setValue(found.Iban);
                        this.selectedIBAN.emit(found);
                    }
                }
            });
        });
    }

    setDefaultIban() {
        if (!this.userIbans || this.userIbans.length === 0)
            return;

        const defaultIban = this.userIbans.find(({ isDefault }) => isDefault);

        // se nao foi encontrado e o tamanho do array for 1 selecionar esse por defeito 
        if (!defaultIban) {
            if (this.userIbans.length === 1){
                this.ngControl.control.setValue(this.userIbans[0].Iban);
                this.selectedIBAN.emit(this.userIbans[0]);
            }
            return;
        }

        this.ngControl.control.setValue(defaultIban.Iban);
        this.selectedIBAN.emit(defaultIban);
    }

    onChanged: (paymentConditionID: number) => void;
    onTouched: () => void;

    async writeValue(iban: string): Promise<void> { }

    registerOnChange(fn: any): void {
        this.onChanged = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
